import { render, staticRenderFns } from "./travelInfo.vue?vue&type=template&id=0b052756&"
import script from "./travelInfo.vue?vue&type=script&lang=js&"
export * from "./travelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports